import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ProductsList.styled";
import removalIcon from "@icons/ic-removal.svg";
import supplyIcon from "@icons/ic-supply.svg";

const GeneralInfo = (props) => {
  const { t, data, column, page } = props;

  return (
    <>
      {(data.status || page == "view") && (
        <DivBackgroundFullOpacity>
          {column === "operation" && data.canDelivery && (
            <p>
              <Image src={supplyIcon} alt="SUPPLY" title={t("SUPPLY")} />{" "}
              {t("SUPPLY")}
            </p>
          )}
          {column === "operation" && data.canEvacuate && (
            <p>
              <Image src={removalIcon} alt="REMOVAL" title={t("REMOVAL")} />{" "}
              {t("REMOVAL")}
            </p>
          )}

          {column !== "operation" && <div>{data.name}</div>}
        </DivBackgroundFullOpacity>
      )}
      {page != "view" && !data.status && (
        <DivBackgroundLowOpacity>
          {column === "operation" && data.canDelivery && (
            <p>
              <Image src={supplyIcon} alt="SUPPLY" title={t("SUPPLY")} />{" "}
              {t("SUPPLY")}
            </p>
          )}
          {column === "operation" && data.canEvacuate && (
            <p>
              <Image src={removalIcon} alt="REMOVAL" title={t("REMOVAL")} />{" "}
              {t("REMOVAL")}
            </p>
          )}

          {column !== "operation" && <div>{data.name}</div>}
        </DivBackgroundLowOpacity>
      )}
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  column: PropTypes.string,
  page: PropTypes.string,
};
GeneralInfo.defaultProps = {
  column: null,
  page: null,
};

export default withTranslation()(GeneralInfo);
